import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './SummaryBlock.scss'
import DealerSummary from './DealerSummary/DealerSummary'
import DealerSearch from './DealerSearch/DealerSearch'
import VehicleSummary from './VehicleSummary'
import { useSelector, useDispatch } from 'react-redux';
import { isMobile } from '../../helpers/helpers';
import PopIn from '../PopIn/PopIn'
import CONSTANTS from '../../Constants'
import { setDealerDetails } from '../../redux-files/actions/action';
import dealerRepairImg from '../../images/AP/ap-after-sale.svg'
import vehicleImg from '../../images/AP/Car_Outline.svg'
import AppointmentSummaryBlock from './AppointmentSummaryBlock';
import { pushEventToGTM } from '../../helpers/trackerManager';

const defaultProps = {
    handleDealerSearch: () => { }
}
const SummaryBlock = ({ handleDealerSearch = defaultProps.handleDealerSearch, showAppointmentBlock = false }) => {
    const selectedForfaits = useSelector(state => state.ndel_store.selectedForfaits)
    const [isDealerChoosen, setIsDealerChoosen] = useState(false)
    const [showDealerInfosPopIn, setShowDealerInfosPopIn] = useState(false)
    const [showVehiculeInfosPopIn, setShowVehiculeInfosPopIn] = useState(false)
    const dealer = useSelector(state => state.ndel_store.dealer)
    const vehicleInfo = useSelector(state => state.ndel_store.vehicleInfo)
    const appointmentInfo = useSelector(state => state.ndel_store.appointment)
    const dispatch = useDispatch()
    const location = useLocation()
    const navigate = useNavigate();
    useEffect(() => {
        if (dealer.iD !== 0 && !dealer.editDealer) {
            setIsDealerChoosen(true)
        } else {
            setIsDealerChoosen(false)
        }
    }, [dealer, dealer.editDealer]
    );

    const changeDealer = () => {
        setShowDealerInfosPopIn(false)
        dispatch(setDealerDetails({
            ...dealer,
            editDealer: true,
            isFromAppointmentPage: location.pathname === CONSTANTS.SITE_ROUTS.YOURAPPOINTMENTPAGE
        }))
        pushEventToGTM({
            pageName: 'all',
            eventAction: 'Redirection::Internal::Dealers',
            eventLabel: CONSTANTS.LABELS.quote_alert_dealer,
            eventCategory: 'Header'
        })
        navigate(CONSTANTS.SITE_ROUTS.OPERATIONSPAGE)
    }
    const changeVehicle = () => {
        pushEventToGTM({
            pageName: 'all',
            eventAction: 'Redirection::Internal::CarDetails',
            eventLabel: CONSTANTS.LABELS.quote_alert_vehicle,
            eventCategory: 'Header'
        })
        navigate(CONSTANTS.SITE_ROUTS.VEHICLEPAGE)
    }
    const handleEditClick = (type) => {
        if (selectedForfaits.length > 0) {
           if(type === 'vehicle' ){
               setShowVehiculeInfosPopIn(true)
               pushEventToGTM({
                pageName: 'all',
                eventAction: 'Display::Popin::Vehicle',
                eventLabel: CONSTANTS.LABELS.common_v2_modify,
                eventCategory: 'Header'
            })
           } 
            if(type === 'dealer') {
                setShowDealerInfosPopIn(true)
                pushEventToGTM({
                    pageName: 'all',
                    eventAction: 'Display::Popin::Dealer',
                    eventLabel: CONSTANTS.LABELS.common_v2_modify,
                    eventCategory: 'Header'
                })
            } 
        } else {
            if(type === 'vehicle') {
                pushEventToGTM({
                    pageName: 'dealer locator',
                    eventAction: 'Redirection::Internal::CarDetails',
                    eventLabel: CONSTANTS.LABELS.common_v2_modify,
                    eventCategory: 'Dealerlocator'
                })
                navigate(CONSTANTS.SITE_ROUTS.VEHICLEPAGE)
            } 
            if (type === 'dealer') {
                dispatch(setDealerDetails({
                    ...dealer,
                    editDealer: true
                }))
                navigate(CONSTANTS.SITE_ROUTS.OPERATIONSPAGE)
            }

        }

    }
    const dealerChoosenStyle = dealer.iD !== 0 ? { color: '#0074E8' } : {}
    const vehiculeChoosenStyle = Object.keys(vehicleInfo).length > 0 ? { color: '#0074E8' } : {}
    const popInDealerContent = <div className='popin-dealer'>
        <h4 className='content-dealer-name'>{`${dealer.name}`}</h4>
        <p className='content-dealer-adress'>{`${dealer.adress} ${dealer.zip} ${dealer.city}`} </p>
        <p className='content-alert'>{CONSTANTS.LABELS.quote_alert_modif}</p>
    </div>
    const popInVehicleContent = <div className='popin-vehicle'>
        <h4 className='content-vehicle-name'>{`${vehicleInfo.ModelLabel} ${vehicleInfo.EnergyLabel}`}</h4>
        <div className='content-vehicle-infos'>
            <p className='content-vehicle-id'>{vehicleInfo.Registration || vehicleInfo.SerialNumber || '-'}</p>
            <p className='content-vehicle-mileage'>{vehicleInfo.Mileage} {CONSTANTS.LABELS.vehicule_step2_km2}</p>
<p className='content-vehicle-service'>{vehicleInfo.contratService ? CONSTANTS.LABELS.summary_vehicule_warranty_true : CONSTANTS.LABELS.summary_vehicule_warranty_false}</p>
        </div>
        <p className='content-alert'>{CONSTANTS.LABELS.quote_alert_modif}</p>
    </div>
    return (
        <>
            <div className='summaryBlock'>
                {!isMobile() ?
                    <>
                        {isDealerChoosen ?
                            <DealerSummary
                                dealerName={dealer.name}
                                dealerCity={dealer.city}
                                dealerZipCode={dealer.zip}
                                dealerAddress={dealer.adress}
                                onEditClick={handleEditClick}
                            />
                            : <DealerSearch
                                onDealerSearch={(searchedAdress) => handleDealerSearch(searchedAdress)}
                            />
                        }
                        
                        {showAppointmentBlock && <AppointmentSummaryBlock
                            date={appointmentInfo.dayDate}
                            hour={appointmentInfo.hour}
                        />
                        }
                        <VehicleSummary
                            vehicleName={`${vehicleInfo.ModelLabel} ${vehicleInfo.EnergyLabel}`}
                            vehicleMileage={vehicleInfo.Mileage}
                            vehicleSerialNumber={vehicleInfo.SerialNumber}
                            vehicleRegistration={vehicleInfo.Registration}
                            onEditClick={handleEditClick}
                        />
                    </>
                    :
                    <>

                        <div onClick={() => handleEditClick('vehicle')} style={vehiculeChoosenStyle} className='myvehicle'> {CONSTANTS.LABELS.header_quote_mobile1}</div>
                        <div onClick={() => handleEditClick('dealer')} style={dealerChoosenStyle} className='mydealer'>{CONSTANTS.LABELS.header_quote_mobile2}</div>

                    </>
                }
            </div>
            {
                showVehiculeInfosPopIn && <PopIn
                    title={CONSTANTS.LABELS.header_quote_ariane1}
                    content={popInVehicleContent}
                    titlePicto={
                        {
                            showTitlePicto: isMobile() && true,
                            src: vehicleImg,
                            alt: 'warning'
                        }
                    }
                    inverseButtons={true}
                    primaryButtonLabel={CONSTANTS.LABELS.common_v2_continue}
                    secondaryButtonLabel={CONSTANTS.LABELS.quote_alert_vehicle}
                    handlePrimaryButton={() =>{
                        pushEventToGTM({
                            pageName: 'all',
                            eventAction: 'Close::Popin::Vehicle',
                            eventLabel: CONSTANTS.LABELS.common_v2_continue,
                            eventCategory: 'Header'
                        })
                        setShowVehiculeInfosPopIn(false)
                    } }
                    handleSecondaryButton={changeVehicle}
                />
            }
            {showDealerInfosPopIn && <PopIn
                    title={CONSTANTS.LABELS.dealer_quote_mobile1}
                    titlePicto={
                        {
                            showTitlePicto: isMobile() && true,
                            src: dealerRepairImg,
                            alt: 'warning'
                        }
                    }
                    content={popInDealerContent}
                    inverseButtons={true}
                    primaryButtonLabel={CONSTANTS.LABELS.common_v2_continue}
                    secondaryButtonLabel={CONSTANTS.LABELS.quote_alert_dealer}
                    handlePrimaryButton={() => {
                        pushEventToGTM({
                            pageName: 'all',
                            eventAction: 'Close::Popin::Dealer',
                            eventLabel: CONSTANTS.LABELS.common_v2_continue,
                            eventCategory: 'Header'
                        })
                        setShowDealerInfosPopIn(false)
                    }}
                    handleSecondaryButton={changeDealer}
                />
                        }
        </>
    );


}

export default SummaryBlock;